module.exports = __webpack_public_path__ + "static/media/ba.32253f32.png";